import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  isMobileViewEnable: false,
}

export const screenViewSlice = createSlice({
  name: 'screenView',
  initialState,
  reducers: {
    mobileViewStatus(state, action) {
      state.isMobileViewEnable = action.payload
    },
  },
})

export const {mobileViewStatus} = screenViewSlice.actions
export default screenViewSlice.reducer
